import { ORDER_PAYMENT_SUCCESS_SHOW_RECIEPT } from "./orderconfirmConstantTypes";

export const OrderConfirmReducer=(state={},action)=> {
    let payload=action.payload|| undefined;
    if(payload===undefined || payload===null || payload===0){
        payload={orderConfirmData:{}};
    }
    switch (action.type) {
        case ORDER_PAYMENT_SUCCESS_SHOW_RECIEPT:
       
            return payload
        default: return state;
            
    }
}